import { EngagementType } from 'domain/shared/types/engagement-types';
import React from 'react';

interface IActivityListContext {
  engagementTypes: EngagementType[]
}

export const ActivityListContext = React.createContext({} as IActivityListContext);
export const ActivityListContextProvider = ActivityListContext.Provider;
